import '@fortawesome/fontawesome-free/css/all.css'
import './styles/style.scss'

import carrier from './images/carrier-logo.png'

import { runApp } from '@/app-loader'

runApp({
  name: 'Claro Recarga - Pagamento PIX',
  images: {
    carrier
  }
})
